import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { catchError, EMPTY, filter, map, takeUntil, tap } from 'rxjs';

import { ConsentTextInfoRestService } from '../services/consent-test-info-rest.service';
import { Unsubscribe } from '../shared/classes/unsubscribe.class';
import { accessToken, cacChubSSNId } from '../shared/state/local-cache';

export const SMS_CONSENT_TYPE = 'SMS';

@Component({
  selector: 'capq-sms-consent',
  templateUrl: './sms-consent.component.html',
  styleUrls: ['./sms-consent.component.scss'],
  standalone: false,
})
export class SmsConsentComponent extends Unsubscribe implements OnInit {
  @Output() setConsent = new EventEmitter<boolean>();

  smsConsentAgreed = new FormControl(false);
  smsConsentContent = '';
  smsConsentVersion = '';
  smsConsentTextId = 0;

  constructor(
    private readonly consentTextInfoRestService: ConsentTextInfoRestService,
    private readonly cdRef: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.consentTextInfoRestService
      .getConsentByType(SMS_CONSENT_TYPE)
      .pipe(
        tap(({ headers }) => {
          const token = headers?.get('access-token');
          if (token) accessToken(token);

          const ssid = headers?.get('cac-chub-ssid');
          if (ssid) cacChubSSNId(ssid);
        }),
        map(({ body }) => body?.getConsentByType),
        filter(Boolean),
        catchError((error) => {
          console.error('Failed to load SMS consent:', error);
          return EMPTY;
        }),
        takeUntil(this.unsubscribe$)
      )
      .subscribe(({ consenttext, consenttextid, consentversion }) => {
        this.smsConsentContent = consenttext;
        this.smsConsentTextId = consenttextid;
        this.smsConsentVersion = consentversion;
        this.cdRef.detectChanges();
      });

    this.smsConsentAgreed.valueChanges
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((value) => {
        this.setConsent.emit(value ?? false);
      });
  }

  /** Programmatically reset the consent checkbox. */
  resetConsent(): void {
    this.smsConsentAgreed.setValue(false);
  }
}
